import React, { useState, useCallback, useEffect } from 'react';

type ShareLinkModalProps = {
  isOpen: boolean;
  onClose: () => void;
  files: Record<string, string>;
  projectName: string;
};

// LZ-String compression for URL sharing
function compressToEncodedURIComponent(input: string): string {
  if (!input) return '';

  const keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$';

  function compress(uncompressed: string, bitsPerChar: number, getCharFromInt: (a: number) => string): string {
    let i: number;
    let value: number;
    const context_dictionary: Record<string, number> = {};
    const context_dictionaryToCreate: Record<string, boolean> = {};
    let context_c = '';
    let context_wc = '';
    let context_w = '';
    let context_enlargeIn = 2;
    let context_dictSize = 3;
    let context_numBits = 2;
    let context_data: string[] = [];
    let context_data_val = 0;
    let context_data_position = 0;

    for (let ii = 0; ii < uncompressed.length; ii++) {
      context_c = uncompressed.charAt(ii);
      if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
        context_dictionary[context_c] = context_dictSize++;
        context_dictionaryToCreate[context_c] = true;
      }

      context_wc = context_w + context_c;
      if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) {
        context_w = context_wc;
      } else {
        if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
          if (context_w.charCodeAt(0) < 256) {
            for (i = 0; i < context_numBits; i++) {
              context_data_val = (context_data_val << 1);
              if (context_data_position === bitsPerChar - 1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
            }
            value = context_w.charCodeAt(0);
            for (i = 0; i < 8; i++) {
              context_data_val = (context_data_val << 1) | (value & 1);
              if (context_data_position === bitsPerChar - 1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          } else {
            value = 1;
            for (i = 0; i < context_numBits; i++) {
              context_data_val = (context_data_val << 1) | value;
              if (context_data_position === bitsPerChar - 1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = 0;
            }
            value = context_w.charCodeAt(0);
            for (i = 0; i < 16; i++) {
              context_data_val = (context_data_val << 1) | (value & 1);
              if (context_data_position === bitsPerChar - 1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          }
          context_enlargeIn--;
          if (context_enlargeIn === 0) {
            context_enlargeIn = Math.pow(2, context_numBits);
            context_numBits++;
          }
          delete context_dictionaryToCreate[context_w];
        } else {
          value = context_dictionary[context_w];
          for (i = 0; i < context_numBits; i++) {
            context_data_val = (context_data_val << 1) | (value & 1);
            if (context_data_position === bitsPerChar - 1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        }
        context_enlargeIn--;
        if (context_enlargeIn === 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        context_dictionary[context_wc] = context_dictSize++;
        context_w = String(context_c);
      }
    }

    if (context_w !== '') {
      if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
        if (context_w.charCodeAt(0) < 256) {
          for (i = 0; i < context_numBits; i++) {
            context_data_val = (context_data_val << 1);
            if (context_data_position === bitsPerChar - 1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
          }
          value = context_w.charCodeAt(0);
          for (i = 0; i < 8; i++) {
            context_data_val = (context_data_val << 1) | (value & 1);
            if (context_data_position === bitsPerChar - 1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        } else {
          value = 1;
          for (i = 0; i < context_numBits; i++) {
            context_data_val = (context_data_val << 1) | value;
            if (context_data_position === bitsPerChar - 1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = 0;
          }
          value = context_w.charCodeAt(0);
          for (i = 0; i < 16; i++) {
            context_data_val = (context_data_val << 1) | (value & 1);
            if (context_data_position === bitsPerChar - 1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        }
        context_enlargeIn--;
        if (context_enlargeIn === 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        delete context_dictionaryToCreate[context_w];
      } else {
        value = context_dictionary[context_w];
        for (i = 0; i < context_numBits; i++) {
          context_data_val = (context_data_val << 1) | (value & 1);
          if (context_data_position === bitsPerChar - 1) {
            context_data_position = 0;
            context_data.push(getCharFromInt(context_data_val));
            context_data_val = 0;
          } else {
            context_data_position++;
          }
          value = value >> 1;
        }
      }
      context_enlargeIn--;
      if (context_enlargeIn === 0) {
        context_numBits++;
      }
    }

    value = 2;
    for (i = 0; i < context_numBits; i++) {
      context_data_val = (context_data_val << 1) | (value & 1);
      if (context_data_position === bitsPerChar - 1) {
        context_data_position = 0;
        context_data.push(getCharFromInt(context_data_val));
        context_data_val = 0;
      } else {
        context_data_position++;
      }
      value = value >> 1;
    }

    while (true) {
      context_data_val = (context_data_val << 1);
      if (context_data_position === bitsPerChar - 1) {
        context_data.push(getCharFromInt(context_data_val));
        break;
      } else {
        context_data_position++;
      }
    }

    return context_data.join('');
  }

  return compress(input, 6, (a) => keyStr.charAt(a));
}

export const ShareLinkModal = React.memo(function ShareLinkModal({
  isOpen,
  onClose,
  files,
  projectName,
}: ShareLinkModalProps) {
  const [shareUrl, setShareUrl] = useState('');
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const fileEntries = Object.entries(files);
  const totalSize = fileEntries.reduce((sum, [, content]) => sum + content.length, 0);
  const compressedSize = shareUrl.length;

  // Generate share URL on mount
  useEffect(() => {
    if (!isOpen) return;

    setLoading(true);
    setError(null);

    try {
      const payload = JSON.stringify({
        name: projectName,
        files: files,
      });

      // Check if payload is too large (limit to ~50KB for URL)
      if (payload.length > 100000) {
        setError('Project is too large to share via URL. Consider using Export to GitHub Gist instead.');
        setLoading(false);
        return;
      }

      const compressed = compressToEncodedURIComponent(payload);
      const baseUrl = window.location.origin + window.location.pathname;
      const url = `${baseUrl}#share=${compressed}`;

      // Check final URL length
      if (url.length > 50000) {
        setError('Compressed project is too large for URL sharing. Consider using Export to GitHub Gist.');
      } else {
        setShareUrl(url);
      }
    } catch (err) {
      setError('Failed to generate share link');
    } finally {
      setLoading(false);
    }
  }, [isOpen, files, projectName]);

  const handleCopy = useCallback(async () => {
    if (!shareUrl) return;

    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setError('Failed to copy to clipboard');
    }
  }, [shareUrl]);

  const handleClose = useCallback(() => {
    setCopied(false);
    setError(null);
    setShareUrl('');
    onClose();
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={handleClose}>
      <div
        className="modal share-link-modal"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '550px' }}
      >
        <div className="modal-header">
          <div className="modal-title">Share Project</div>
          <button className="modal-close" onClick={handleClose}>
            x
          </button>
        </div>

        <div className="modal-body" style={{ padding: '16px' }}>
          <div style={{
            padding: '12px',
            background: 'var(--bg-secondary)',
            borderRadius: '4px',
            marginBottom: '16px',
          }}>
            <div style={{ fontSize: '12px', color: 'var(--muted)', marginBottom: '4px' }}>
              Project: {projectName}
            </div>
            <div style={{ fontSize: '13px' }}>
              {fileEntries.length} file{fileEntries.length !== 1 ? 's' : ''} ({(totalSize / 1024).toFixed(1)} KB)
              {shareUrl && (
                <span style={{ color: 'var(--muted)' }}>
                  {' '} Compressed: {(compressedSize / 1024).toFixed(1)} KB
                </span>
              )}
            </div>
          </div>

          {loading && (
            <div style={{
              padding: '20px',
              textAlign: 'center',
              color: 'var(--muted)',
            }}>
              Generating share link...
            </div>
          )}

          {error && (
            <div style={{
              padding: '12px',
              background: 'rgba(255, 100, 100, 0.1)',
              border: '1px solid var(--error)',
              borderRadius: '4px',
              marginBottom: '16px',
              color: 'var(--error)',
              fontSize: '13px',
            }}>
              {error}
            </div>
          )}

          {shareUrl && !error && (
            <>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', color: 'var(--muted)' }}>
                  Share URL:
                </label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <input
                    type="text"
                    readOnly
                    value={shareUrl}
                    style={{
                      flex: 1,
                      padding: '8px',
                      background: 'var(--bg-secondary)',
                      border: '1px solid var(--border)',
                      borderRadius: '4px',
                      color: 'var(--text)',
                      fontSize: '12px',
                      fontFamily: 'monospace',
                    }}
                    onFocus={(e) => e.target.select()}
                  />
                  <button
                    className="pill-btn"
                    onClick={handleCopy}
                    style={{
                      background: copied ? 'var(--success)' : undefined,
                      color: copied ? 'white' : undefined,
                    }}
                  >
                    {copied ? 'Copied!' : 'Copy'}
                  </button>
                </div>
                <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
                  URL length: {shareUrl.length.toLocaleString()} characters
                </div>
              </div>

              <div style={{
                padding: '12px',
                background: 'var(--bg-secondary)',
                borderRadius: '4px',
                fontSize: '12px',
              }}>
                <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>How it works:</div>
                <ul style={{ margin: 0, paddingLeft: '16px', color: 'var(--muted)' }}>
                  <li>Project files are compressed and encoded in the URL</li>
                  <li>Anyone with the link can open the project in their browser</li>
                  <li>No server or sign-in required</li>
                  <li>Files are not stored anywhere - the link IS the project</li>
                </ul>
              </div>
            </>
          )}

          {error && (
            <div style={{
              padding: '12px',
              background: 'var(--bg-secondary)',
              borderRadius: '4px',
              fontSize: '12px',
              marginTop: '8px',
            }}>
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Alternative options:</div>
              <ul style={{ margin: 0, paddingLeft: '16px', color: 'var(--muted)' }}>
                <li>Use &quot;Export to GitHub Gist&quot; for larger projects</li>
                <li>Use &quot;Export to CodeSandbox&quot; or &quot;StackBlitz&quot;</li>
                <li>Use &quot;Download as ZIP&quot; and share the file</li>
              </ul>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="pill-btn" onClick={handleClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
});

export default ShareLinkModal;
